import type { TrackerGridCallbacks } from "./TrackerGridHandle";

const noopCallbacks: TrackerGridCallbacks = {
  onChange: () => {},
};

let callbacks: TrackerGridCallbacks = noopCallbacks;

export function setTrackerGridCallbacks(next: TrackerGridCallbacks): void {
  callbacks = next;
}

export function getTrackerGridCallbacks(): TrackerGridCallbacks {
  return callbacks;
}
